import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsDeleteModal } from '@/learnpaths/components/LearnpathsAddElementsDeleteModal/LearnpathsAddElementsDeleteModal'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(scorm)/delete/scorm/$elementId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsDeleteModal elementType="scorm" {...params} />
}
